import { useMutation, useQueryClient } from '@tanstack/react-query';
import { StatusCode, REACT_QUERY_KEYS } from '@hungryroot/rest';
import { patchApiV2CustomersCustomerIdDietaryRestrictions } from '@hungryroot/rest/api/v2/customers/[id]/dietary_restrictions/patch';

interface DietaryRestrictionsPayload {
  id: number;
  selected: boolean;
}

export function usePatchCustomerDietaryRestrictions() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (params: {
      payload: { dietary_restrictions: DietaryRestrictionsPayload[] };
    }) => {
      const { payload } = params;
      const res = await patchApiV2CustomersCustomerIdDietaryRestrictions({
        requestBody: payload,
      });
      if (res.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(res.data, null, 2));
      }
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [REACT_QUERY_KEYS.CUSTOMERS, 'customerDietaryRestrictions'],
      });
    },
  });
}
